import DigitalMarketingServicePage from '../digital-marketing/DigitalMarketingServicePage';
import { getDigitalMarketingService } from '../digital-marketing/services';

const EmailMarketing = () => {
  const service = getDigitalMarketingService('email-marketing');
  if (!service) return null;
  return <DigitalMarketingServicePage service={service} />;
};

export default EmailMarketing;
